import { AddressVoData } from "../..";
import { CheckUtils } from "../check-utils";
var AddressConverter = /** @class */ (function () {
    function AddressConverter() {
    }
    AddressConverter.convertToAddressVoData = function (address, target) {
        if (CheckUtils.isEmpty(address))
            return null;
        var result = (CheckUtils.isEmpty(target)) ? new AddressVoData(address.id) : target;
        result.address1 = address.address1;
        result.address2 = address.address2;
        result.city = address.city;
        result.country = address.country;
        result.state = address.state;
        result.zip = address.zip;
        return result;
    };
    return AddressConverter;
}());
export { AddressConverter };
//# sourceMappingURL=address-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/address-converter.js
// module id = 963
// module chunks = 14